module.exports = __webpack_public_path__ + "img/stepsClose.854fdcbd.svg";